export default __webpack_public_path__ + "static/media/icon_payment.29873622.svg";